export default __webpack_public_path__ + "static/media/sensor.9399d16a.svg";